<div class="map-wrapper modern-marker-map">
    <div id="map-{{mapNumber}}" style="width: 100%; height: 100%;"></div>
</div>

<app-filter *ngIf="dashboardView!=''"
    [displayFilterPopup]="displayFilterPopup"
    [filterPopupOnly]="true"
    [channelList]="channelList"
    [selectedChannel]="selectedChannel"
    [showTerritoryChannelFilter]="true"
    [territoryNamesList]="territoryNamesList"
    [selectedTerritory]="selectedTerritory"
    (onChangeChannel)="onChangeChannel($event)"
    (onCloseFilterPopup)="closeFilterPopup()"
    (onAllFilterApply)="allFiltersChanges($event)"
    (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
 >
</app-filter>
